import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

// Goes back to the previous page inside the app, or to the home page when there is none
// (for example when the visitor opened /login directly).
const BackLink = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHistory = location.key !== 'default';

  return (
    <button
      type="button"
      className="auth-page__back"
      onClick={() => (hasHistory ? navigate(-1) : navigate('/'))}
    >
      <FiArrowLeft aria-hidden="true" />
      {hasHistory ? 'Back' : 'Back to home'}
    </button>
  );
};

export default BackLink;
